import { combineReducers, configureStore } from "@reduxjs/toolkit";

import { sessionReducer as session } from "./session";
import { devicesReducer as devices } from "./devices";
import { positionsReducer as positions } from "./positions";
import { routesReducer as routes } from "./routes";
import { eventsReducer as events } from "./events";
import { speedometerReducer as speedometer } from "./speedometer";
import { usersReducer as users } from "./users";
import { reducer as applications } from "./applications";

const reducer = combineReducers({
    session,
    devices,
    positions,
    routes,
    events,
    speedometer,
    users,
    applications,
});

export { sessionActions } from "./session";
export { devicesActions } from "./devices";
export { positionsActions } from "./positions";
export { routesActions } from "./routes";
export { eventsActions } from "./events";
export { speedometerActions } from "./speedometer";
export { usersActions } from "./users";
export { actions as applicationsActions } from "./applications";

export default configureStore({ reducer, middleware: [] });
